import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Col,
  DatePicker,
  Input,
  InputNumber,
  Modal,
  notification,
  Row,
  Space,
  Switch,
  Typography,
} from 'antd';
import { duplicatePreset, fetchMissingEodPrices, selectors } from 'state';

type Props = {
  preset_name: string;
  preset_id: number;
  visible: boolean;
  hide: () => void;
};

const DuplicatePresetModal: React.FC<Props> = ({
  preset_name,
  preset_id,
  visible,
  hide,
}) => {
  const dispatch = useDispatch();
  const waiting = useSelector(selectors.waiting);

  const [newName, setNewName] = useState<string>(`${preset_name} (copy)`);

  const onNameChange = (value: string | undefined) => {
    if (value !== undefined) setNewName(value);
  };

  const onCancel = () => hide();

  return (
    <Modal
      title={`Duplicate preset: ${preset_name}`}
      open={visible}
      onCancel={onCancel}
      footer={[]}
      width={500}
    >
      <div style={{ textAlign: 'right' }}>
        <Input
          value={newName}
          onChange={value => onNameChange(value.target.value)}
        />
        <Button
          style={{ marginTop: 25 }}
          type={'primary'}
          onClick={() =>
            dispatch(
              duplicatePreset({ preset_id: preset_id, new_name: newName })
            )
          }
        >
          Duplicate
        </Button>
      </div>
    </Modal>
  );
};

export default DuplicatePresetModal;
